import { combineReducers } from "@ngrx/store";
import { SportsbookEventReducer } from "@sports-features/event/stores/event.reducers";
import { SportsbookHomeReducer } from "@sports-features/home/stores/home.reducers";
import { SportsbookLiveMarketReducer } from "@sports-features/live-market/stores/live-market.reducers";
import { SportsbookLiveReducer } from "@sports-features/live/stores/live.reducers";
import { SportsbookMarketReducer } from "@sports-features/market-page/stores/market.reducers";
import { SportsbookRaceMarketReducer } from "@sports-features/race-market/stores/race-market.reducers";
import { SportsbookRaceReducer } from "@sports-features/race/stores/race.reducers";
import { SportsbookSportCountriesReducer } from "@sports-features/sport-countries/stores/sport-countries.reducers";
import { SportsbookTodayReducer } from "@sports-features/today/stores/today.reducers";
import {
  C_CategoryInfo,
  configDataModel,
  eventDataModel,
  homeDataModel,
  liveDataModel,
  liveMarketDataModel,
  marketDataModel,
  navigationModel,
  raceDataModel,
  raceMarketDataModel,
  sportCountriesDataModel,
  todayDataModel,
} from "@sports-models/index";
import { SportsbookConfigReducer } from "./common-reducers/config.reducers";
import { SportsbookErrorReducer } from "./common-reducers/error.reducers";
import { SportsbookNavigationReducer } from "./common-reducers/navigation.reducers";

export interface SportsbookState {
  homeData: homeDataModel;
  sportCountriesData: sportCountriesDataModel;
  eventData: eventDataModel;
  marketData: marketDataModel;
  liveData: liveDataModel;
  liveMarketData: {
    prevLiveMarketData: liveMarketDataModel;
    currentLiveMarketData: liveMarketDataModel;
    categories: C_CategoryInfo[];
    selectedCategory: C_CategoryInfo;
    market: any;
  };
  raceData: raceDataModel;
  raceMarketData: raceMarketDataModel;
  todayData: todayDataModel;
  specialTeamData: any[];
  sportEventsData: any[];
  navigationData: navigationModel;
  error: any;
  config: configDataModel;
}

export const SportsbookReducer = combineReducers({
  homeData: SportsbookHomeReducer,
  config: SportsbookConfigReducer,
  navigationData: SportsbookNavigationReducer,
  sportCountriesData: SportsbookSportCountriesReducer,
  eventData: SportsbookEventReducer,
  marketData: SportsbookMarketReducer,
  todayData: SportsbookTodayReducer,
  liveData: SportsbookLiveReducer,
  liveMarketData: SportsbookLiveMarketReducer,
  raceData: SportsbookRaceReducer,
  raceMarketData: SportsbookRaceMarketReducer,
  error: SportsbookErrorReducer,
});
